import { render } from "./PicDialog.vue?vue&type=template&id=2efdc8d5"
import script from "./PicDialog.vue?vue&type=script&lang=js"
export * from "./PicDialog.vue?vue&type=script&lang=js"

import "./PicDialog.vue?vue&type=style&index=0&id=2efdc8d5&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__